var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { grow: "" } },
    [
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { staticClass: "inputs", attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("friendly-id"), fancy: "" },
                    model: {
                      value: _vm.value.ComputedFriendlyID,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "ComputedFriendlyID", $$v)
                      },
                      expression: "value.ComputedFriendlyID",
                    },
                  }),
                  _c("app-select-journal", {
                    attrs: {
                      label: _vm.$ct("journal"),
                      fancy: "",
                      disabled: !_vm.hasJournalModule,
                      "filter-to-journals-with-purchase-number": "",
                    },
                    model: {
                      value: _vm.value.JournalID,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "JournalID", $$v)
                      },
                      expression: "value.JournalID",
                    },
                  }),
                  _c("w-input", {
                    attrs: { label: _vm.$ct("invoice-nr"), fancy: "" },
                    on: {
                      blur: function ($event) {
                        return _vm.checkInvoiceExists()
                      },
                    },
                    model: {
                      value: _vm.value.InvoiceNR,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "InvoiceNR", $$v)
                      },
                      expression: "value.InvoiceNR",
                    },
                  }),
                  _c("w-date-picker", {
                    attrs: { label: _vm.$ct("invoice-date"), fancy: "" },
                    on: {
                      input: function ($event) {
                        return _vm.changeSettings()
                      },
                    },
                    model: {
                      value: _vm.value.InvoiceDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "InvoiceDate", $$v)
                      },
                      expression: "value.InvoiceDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      "calculate-decimals": 0,
                      decimals: 0,
                      label: _vm.$ct("vat-period"),
                      max: 12,
                      min: 1,
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.VatPeriod,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "VatPeriod", $$v)
                      },
                      expression: "value.VatPeriod",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      "calculate-decimals": 0,
                      decimals: 0,
                      label: _vm.$ct("vat-year"),
                      min: 0,
                      icon: "info-circle",
                      fancy: "",
                    },
                    on: {
                      "icon-click": function ($event) {
                        return _vm.onVatYearInfoClick()
                      },
                    },
                    model: {
                      value: _vm.value.VatYear,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "VatYear", $$v)
                      },
                      expression: "value.VatYear",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      "calculate-decimals": 0,
                      decimals: 0,
                      label: _vm.$ct("accounting-period"),
                      max: 12,
                      min: 1,
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.AccountingPeriod,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "AccountingPeriod", $$v)
                      },
                      expression: "value.AccountingPeriod",
                    },
                  }),
                  _c(
                    "div",
                    { style: { display: "flex", flexDirection: "row" } },
                    [
                      _vm.isAllowedMultiValuta
                        ? _c("app-currency-select", {
                            staticClass: "mrs",
                            attrs: { fancy: "" },
                            model: {
                              value: _vm.value.CurrencyID,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "CurrencyID", $$v)
                              },
                              expression: "value.CurrencyID",
                            },
                          })
                        : _vm._e(),
                      _c("w-input-currency", {
                        style: { flexGrow: 1 },
                        attrs: {
                          "currency-rate": _vm.currencyRate,
                          currency: _vm.value.CurrencyID,
                          label: _vm.$ct("total"),
                          decimals: 2,
                          fancy: "",
                        },
                        on: {
                          blur: function ($event) {
                            return _vm.toggleType()
                          },
                        },
                        model: {
                          value: _vm.value.Total,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "Total", $$v)
                          },
                          expression: "value.Total",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                      },
                    },
                    [
                      _c("w-input-number", {
                        staticClass: "mrs",
                        style: { flexGrow: 1 },
                        attrs: { label: _vm.$ct("discount"), fancy: "" },
                        on: {
                          blur: _vm.onPaymentBeforeDiscountPercentageChange,
                        },
                        model: {
                          value: _vm.value.DiscountPercantage,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "DiscountPercantage", $$v)
                          },
                          expression: "value.DiscountPercantage",
                        },
                      }),
                      _c("w-input-number", {
                        style: { flexGrow: 1 },
                        attrs: {
                          decimals: 2,
                          label: _vm.$ct("discount-amount"),
                          fancy: "",
                        },
                        on: { blur: _vm.onPaymentBeforeDiscountAmountChange },
                        model: {
                          value: _vm.PaymentBeforeDiscountAmount,
                          callback: function ($$v) {
                            _vm.PaymentBeforeDiscountAmount = $$v
                          },
                          expression: "PaymentBeforeDiscountAmount",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.value.DiscountPercantage != 0
                    ? _c("w-date-picker", {
                        attrs: {
                          label: _vm.$ct("payment-before-discount-date"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.value.PaymentBeforeDiscountDate,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.value,
                              "PaymentBeforeDiscountDate",
                              $$v
                            )
                          },
                          expression: "value.PaymentBeforeDiscountDate",
                        },
                      })
                    : _vm._e(),
                  _c("w-date-picker", {
                    attrs: { label: _vm.$ct("expiration-date"), fancy: "" },
                    model: {
                      value: _vm.value.ExpirationDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "ExpirationDate", $$v)
                      },
                      expression: "value.ExpirationDate",
                    },
                  }),
                  _c("w-radio", {
                    attrs: {
                      checked: !_vm.value.IsCreditNote,
                      label: _vm.$ct("type-invoice"),
                      name: "purchase-type",
                    },
                    on: {
                      input: function ($event) {
                        _vm.value.IsCreditNote = false
                      },
                    },
                  }),
                  _c("w-radio", {
                    attrs: {
                      checked: _vm.value.IsCreditNote,
                      label: _vm.$ct("type-creditnote"),
                      name: "purchase-type",
                    },
                    on: {
                      input: function ($event) {
                        _vm.value.IsCreditNote = true
                      },
                    },
                  }),
                  _c("w-textarea", {
                    attrs: { label: _vm.$ct("communication"), fancy: "" },
                    on: {
                      blur: function ($event) {
                        return _vm.checkOgm()
                      },
                    },
                    model: {
                      value: _vm.value.Communication,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Communication", $$v)
                      },
                      expression: "value.Communication",
                    },
                  }),
                  _c("w-input-ogm", {
                    attrs: { label: _vm.$ct("ogm") },
                    model: {
                      value: _vm.value.Ogm,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Ogm", $$v)
                      },
                      expression: "value.Ogm",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }